@if (accessories && accessories.length) {
  <h5>{{ label | transloco }}</h5>
}
@if (accessories && accessories.length && sublabel) {
  <p>{{ sublabel | transloco }}</p>
}
<boels-accordion [mode]="accordionMode">
  @for (accessory of accessories; track accessory) {
    <boels-accordion-item>
      <div slot="header">
        <div class="title-container p-0">
          <button class="accessory-title">
            <fa-icon
              class="accessory-title__icon"
              [icon]="faChevronDown"
            ></fa-icon>
            <div class="accessory-title__ellipsis">
              {{ accessory.target?.name }}
            </div>
          </button>
        </div>
        <div class="info-container" (click)="$event.stopPropagation()">
          <div
            class="prices accessories-prices"
            [style.grid-template-columns]="productTagsGridStyle"
          >
            @if (accessory.target) {
              @if (
                accessory.target.unitPrices &&
                accessory.target.unitPrices.length > 0
              ) {
                <div class="prices-tag">
                  <div class="prices-tag-label prices-tag-label-nav">
                    {{ 'productDetails.labelFrom' | transloco }}
                  </div>
                  <div class="prices-tag-value-nav">
                    ({{ priceLabel | transloco }})
                  </div>
                </div>
              }

              @for (
                priceObj of getUnitPrices(accessory.target);
                track priceObj
              ) {
                <div class="prices-tag">
                  <div class="prices-tag-title">
                    {{ priceObj.unitName }}
                    @if (priceObj.unit === 'PIECES') {
                      <fa-icon
                        [icon]="faCircleInfo"
                        [ngbTooltip]="
                          'productDetails.perPieceTooltip' | transloco
                        "
                        [tooltipClass]="'ngb-boels-tooltip'"
                        [autoClose]="'inside'"
                        container="body"
                        data-boundary="viewport"
                        tabindex="0"
                        role="button"
                      ></fa-icon>
                      <ng-template #iconTooltip>
                        <div>
                          {{ 'productDetails.perPieceTooltip' | transloco }}
                        </div>
                      </ng-template>
                    }
                  </div>
                  <span class="prices-tag-price info--{{ priceObj.unit }}">
                    {{ priceObj.formattedValue }}
                  </span>
                </div>
              }
            }
          </div>
        </div>
      </div>
      <div slot="content">
        <div class="accessory-content">
          <div class="code">
            {{ 'productDetails.code' | transloco }}
            {{ accessory.target?.code }}
          </div>
          <div
            [innerHTML]="accessory.target?.description"
            class="summary"
            [style.padding-right]="summaryPadding"
          ></div>
        </div>
      </div>
    </boels-accordion-item>
  }
</boels-accordion>
